export default __webpack_public_path__ + "static/media/logo_phone.08d0fae5.svg";